import { Component } from '@angular/core';
import { Platform, AlertController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})

export class AppComponent {
  selectedPath = '';
  public appPages = [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: 'speedometer',
    },
    {
      title: 'My POs',
      url: '/mypos',
      icon: 'list',
    },
    {
      title: 'Approvals',
      url: '/approvals',
      icon: 'checkmark',
    },
    {
      title: 'Receive PO',
      url: '/receivingpo',
      icon: 'browsers',
    },
    {
      title: 'Logout',
      // url: '/logout',
      icon: 'log-out'
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public alertController: AlertController,
    private router: Router) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  logOutConfirm(p) {
    // console.log("p: " + JSON.stringify(p));
    if (p.title === "Logout") {
      this.showAlertConfirm();
    }
  }

  async showAlertConfirm() {
    const alert = await this.alertController.create({
      header: "Alert...!",
      message: "Are you sure you want to log out?",
      buttons: [
        {
          text: 'Okay',
          handler: () => {
            // console.log("okay clicked");
            this.router.navigate(['/logout']);
          }
        }, {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        }
      ]
    });

    await alert.present();
  }

}
